export const OWNS_SERVICE_KEY = 'owns_service'
export const LANDLINE_KEY = 'landline_phone'
export const KNOWS_AVC_ID_KEY = 'knows_avc_id'
export const AVC_ID_KEY = 'avc_id'
export const GA_EVENT_CATEGORY = 'Owner'



// WEBPACK FOOTER //
// ./containers/stages/OwnerCheckStage/constants.js